import { NgModule } from '@angular/core';
import { TitleCasePipe } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { CountryInfoRoutingModule } from './country-info-routing.module';
import { LocationListModule } from '../../shared/location-list/location-list.module';

import { SafeUrlPipe } from '../../shared/pipes/safe-url.pipe';
import { SafeHtmlPipe } from '../../shared/pipes/safe-html.pipe';
import { ReplaceStrPipe } from '../../shared/pipes/replace-str.pipe';
import { ParseCoordinatesPipe } from '../../shared/pipes/parse-coordinates.pipe';

import { ReadMoreVisibilityDirective } from '../../shared/directives/read-more-visibility.directive';

import { CountryInfoTextService } from './services/country-info-text.service';
import { CountryInfoService } from '../../core/services/country-info.service';
import { CountryInfoParseService } from './services/country-info-parse.service';

import { SearchLinkModule } from '../../shared/search-link/search-link.module';

import { CountryInfoComponent } from './country-info.component';
import { ThingsToDoComponent } from './pages/things-to-do/things-to-do.component';
import { TripsListComponent } from './components/trips-list/trips-list.component';
import { OccasionGeniusService } from '../../core/services/occasion-genius.service';
import { PlacesListComponent } from './components/places-list/places-list.component';
import { GalleryComponent } from '../../shared/components/gallery/gallery.component';
import { SimpleMapComponent } from '../../shared/maps/simple-map/simple-map.component';
import { CityInfoPageComponent } from './pages/city-info-page/city-info-page.component';
import { ViatorComponent } from 'src/app/shared/used-components/viator/viator.component';
import { DynamicHtmlComponent } from './components/dynamic-html-content/dynamic-html-content';
import { RegionInfoPageComponent } from './pages/region-info-page/region-info-page.component';
import { CountryInfoPageComponent } from './pages/country-info-page/country-info-page.component';
import { AudioToursComponent } from '../../shared/used-components/audio-tours/audio-tours.component';
import { SimpleBreadcrumbComponent } from './components/simple-breadcrumb/simple-breadcrumb.component';
import { OccasionGeniusComponent } from '../../shared/components/occasion-genius/occasion-genius.component';
import { PopularItinerariesComponent } from '../../shared/components/popular-itineraries/popular-itineraries.component';
import { SearchInputFieldComponent } from '../../shared/components/forms/search-input-field/search-input-field.component';
import { HotelsBookingContainerComponent } from '../../shared/used-components/hotels-booking-container/hotels-booking-container.component';

@NgModule({
  declarations: [CountryInfoComponent, DynamicHtmlComponent],
  imports: [
    CountryInfoRoutingModule,
    LocationListModule,
    SearchInputFieldComponent,
    MatIconModule,
    SearchLinkModule,
    NgxSkeletonLoaderModule,
    CityInfoPageComponent,
    RegionInfoPageComponent,
    CountryInfoPageComponent,
    SimpleBreadcrumbComponent,
    TripsListComponent,
    PlacesListComponent,
    ParseCoordinatesPipe,
    OccasionGeniusComponent,
    SimpleMapComponent,
    ViatorComponent,
    SafeHtmlPipe,
    AudioToursComponent,
    GalleryComponent,
    PopularItinerariesComponent,
    TranslateModule,
    ReplaceStrPipe,
    ReadMoreVisibilityDirective,
    HotelsBookingContainerComponent,
    ThingsToDoComponent,
    SafeUrlPipe,
    TitleCasePipe,
  ],
  providers: [
    CountryInfoService,
    CountryInfoParseService,
    CountryInfoTextService,
    OccasionGeniusService,
  ],
})
export class CountryInfoModule {}
